export enum DateFormat {
  MMM_DD_YYYY = "MMM_DD_YYYY",
  MM_DD_YY = "MM_DD_YY",
  MM_DD_YYYY = "MM_DD_YYYY",
  DD_MM_YY = "DD_MM_YY",
  DD_MM_YYYY = "DD_MM_YYYY",
  MM_YY = "MM_YY",
  DD_MMM_YYYY = "DD_MMM_YYYY",
  HH_MiMi = "HH_MiMi"
}